<div style="padding: 10px;" fxLayout="row" fxLayout.lt-sm="column" fxLayoutGap="30px">
    <div fxFlex="200px" fxFlex.lt-sm="100%" fxLayout="column" fxLayoutGap="10px">
        <a class="href-link" routerLink="student-card" routerLinkActive="list-item-active">Student Cards</a>
        <a class="href-link" routerLink="corporate-card" routerLinkActive="list-item-active">Corporate Cards</a>
    </div>
    <div fxFlex="100%">
        <router-outlet></router-outlet>
    </div>
</div>